import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { JobOpening } from '../../models/job-opening.interface';

@Component({
  selector: 'app-career-listing',
  standalone: false,
  templateUrl: './career-listing.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./career-listing.component.scss']
})
export class CareerListingComponent {
  @Input() jobs: JobOpening[] = [];
  @Input() isLoading: boolean = false;

  trackByJobId(index: number, job: JobOpening): string {
    return job._id;
  }
}
